export default 'M15.59 4.59a2 2 0 1 0-2.83 2.82L15.34 10H3a2 2 0 0 0 0 4h12.34l-2.58 2.59a2 2 0 1 0 2.83 2.82L23 12z';